import React from 'react';

import { useNavigate } from 'react-router-dom';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea.tsx';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';
import Button from '@/components/ui/buttons/Button';
import { pageTitles } from '@/constants/pageTitles';

import styles from './InviteInquiryPage.module.scss';

const InviteInquiryPage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToMypage = () => {
    navigate('/mypage/profile');
  };

  return (
    <SingleColumnTemplate>
      <div className={styles.InviteInquiryPage}>
        <Jumbotron>
          <JumbotronPanel panelHeaderTitle={pageTitles.inviteEmailConfirm}>
            <JumbotronTitle>学校にお問い合わせください</JumbotronTitle>
            <JumbotronDescription>
              生徒の紐付けが無効の可能性があります。
              <br />
              学校にお問い合わせください。
            </JumbotronDescription>
            <JumbotronButtonArea>
              <Button
                type="button"
                color="primary"
                size="m"
                onClick={handleNavigateToMypage}
              >
                マイページへ
              </Button>
            </JumbotronButtonArea>
          </JumbotronPanel>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default InviteInquiryPage;
